import React, { useEffect, useState, useRef } from "react"
import { Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next"
import { withRouter, Link , useHistory} from "react-router-dom"
import { size, isEmpty } from "lodash"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import SimpleBar from "simplebar-react"
import {
  Card,
  CardBody,
  CardTitle,
  Media,
  CardText,
  Label,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from "reactstrap"
import COADropDown from "../../components/Product/COADropDown"

import * as moment from "moment"
import "@fullcalendar/bootstrap/main.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getAllEmployees as onGetAllEmployees } from "store/products/actions"
import {addEmployeeLedger,getEmpPaymentAndLeaves} from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import DeleteModal from "./DeleteModal";

const EmployeeListDetailed = (props) => {

  const dispatch = useDispatch()
  const history = useHistory()

  const [deleteModal, setDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [events, setEvents] = useState([]);
  const [showLoading, setShowLoading] = useState(false)
  const [searchInProgress, setSearchInProgress] = useState(false)
  const [selectedEmpId, setSelectedEmpId] = useState()
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [employeeFilteredList, setEmployeeFilteredList] = useState([])
  const [payLeaveList, setPayLeaveList] = useState([])
  const [empPayLeaveResp, setEmpPayLeaveResp] = useState({})
  const [modal, setModal] = useState(false);
  const [selectedDay, setSelectedDay] = useState(0);
  const [selectedDayStr, setSelectedDayStr] = useState();
  const [event, setEvent] = useState({});
  const [addType, setAddType] = useState('Payment');
  const [paymentType, setPaymentType] = useState('Salary');
  const [paymentAmount, setPaymentAmount] = useState('0');
  const [paymentComments, setPaymentComments] = useState('');
  const [leaveType, setLeaveType] = useState('Planned');
  const [leaveComments, setLeaveComments] = useState('');
  const [fullDayLeave, setFullDayLeave] = useState(true);
  const [leaveHours, setLeaveHours] = useState('0');
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState({});
  const [fromAccount, setFromAccount] = useState('');
  const [detailedEvents, setDetailedEvents] = useState([])
  const [summaryView, setSummaryView] = useState(true);

  const { employeeList } = useSelector(state => ({
    employeeList: state.Products.employees,
  }))

  const {
    match: { params },
  } = props

  
  useEffect(() => {
    if(selectedEmpId){
      const fileredList = employeeList.filter(each => each.value == selectedEmpId)
      if(fileredList.length == 1){
        setSelectedEmployeeDetails(fileredList[0])
      }
    }
  }, [selectedEmpId, employeeList])
  

  useEffect(() => {
    if (params && params.id) {
      setSelectedEmpId(params.id)
      getAllDetails(params.id)
    } 
  }, [])

  useEffect(() => {
    if (!modal && !isEmpty(event) && !!isEdit) {
      setTimeout(() => {
        setEvent({});
        setIsEdit(false);
      }, 500);
    }
  }, [modal, event]);

  function getAllDetails(empid){
    setShowLoading(true)
    getEmpPaymentAndLeaves({
      inputKey: empid
    })
    .then(resp => {
      if(resp && resp.payLeaveStats){
        setPayLeaveList(resp.payLeaveStats)
      }
      if(resp){
        setEmpPayLeaveResp(resp)
      }
      if(resp && resp.events && resp.events.length > 0){
        processDetailedEvents(resp.events)
        setEvents(convertToCalVO(resp.events))
      }
      setShowLoading(false)
    })
    /*
    getCustomerSummary({
      customerid: custid
    })
    getCustmerSalesList({
      customerid: custid
    })
    */
  }

  async function processDetailedEvents(events){
    const filteredEvents = events.filter(each => (each.addType == 'PAY' || each.addType == 'LEAVE'))
    setDetailedEvents(sortDate(filteredEvents))
  }

  useEffect(() => {
    dispatch(onGetAllEmployees())
  }, [dispatch]);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  

  useEffect(() => {
    setEmployeeFilteredList(employeeList)
    scrollToBottom()
  }, [employeeList])

  function close(){
    history.push('/list-employee')
  }

  const toggle = () => {
    setModal(!modal);
  };

  const handleAddNewLeaveClick = arg => {
    const date1 = moment(new Date()).format("yyyy-MM-DD")
    //console.log('date1::',date1)
    setSelectedDayStr(date1)
    setAddType('Leave')
    setPaymentAmount('0')
    setPaymentComments('')
    setLeaveComments('')
    setLeaveType('Planned')
    setPaymentType('Salary')
    setFullDayLeave(true)
    setLeaveHours('0')

    toggle();
  };

  const handleAddNewPaymentClick = arg => {
    const date1 = moment(new Date()).format("yyyy-MM-DD")
    //console.log('date1::',date1)
    setSelectedDayStr(date1)
    setAddType('Payment')
    setPaymentAmount('0')
    setPaymentComments('')
    setLeaveComments('')
    setLeaveType('Planned')
    setPaymentType('Salary')
    setFullDayLeave(true)
    setLeaveHours('0')

    toggle();
  };

  const handleDateClick = arg => {
    //const date = arg["date"];
    //console.log('date::',arg.dateStr)
    setSelectedDayStr(arg.dateStr)
    setAddType('Payment')
    setPaymentAmount('0')
    setPaymentComments('')
    setLeaveComments('')
    setLeaveType('Planned')
    setPaymentType('Salary')
    setFullDayLeave(true)
    setLeaveHours('0')

    toggle();
  };

  function getEventObj (){
    if(addType == 'Payment'){
      return {
        empid: selectedEmpId,
        addType: addType,
        type: paymentType,
        amount: paymentAmount,
        comments: paymentComments,
        date: selectedDayStr,
        fromAccount: fromAccount,
        clazz: "bg-info" + " text-white",
      };
    }
    else if(addType == 'Leave'){
      return {
        empid: selectedEmpId,
        addType: addType,
        type: leaveType,
        comments: leaveComments,
        date: selectedDayStr,
        clazz: "bg-danger" + " text-white",
        leaveHours: leaveHours
      };
    }
  }

  const handleValidEventSubmit = async (e, values) => {
    if (isEdit) {
      //console.log('values::',values)
      var updateEvent = getEventObj()
      updateEvent = {
        ...updateEvent,
        id: event.id,
      }
      /*
      const date = event['holidaydate'];
      const updateEvent = {
        value: event.value,
        holidaytitle: values.title,
        holidaytype: "ph",
        holidayclazz: "bg-warning" + " text-white",
        holidaydate: date
      };
      */
      setShowLoading(true)
      const response = await onEditItemDirect(updateEvent, addType)
      setShowLoading(false)
      if(response.status == 'success'){
        showSuccessToast('Edited Successfully!!!')
        getAllDetails(selectedEmpId)
        /*
        getEmpPaymentAndLeaves({
          inputKey: selectedEmpId
        })
        .then(resp => {
          if(resp && resp.payLeaveStats){
            setPayLeaveList(resp.payLeaveStats)
          }
          if(resp){
            setEmpPayLeaveResp(resp)
          }
          if(resp && resp.events && resp.events.length > 0){
            setEvents(convertToCalVO(resp.events))
          }
        })*/
      }
    } else {

      var newEvent = getEventObj()

      /*
      if(addType == 'Payment'){
        newEvent = {
          empid: selectedEmpId,
          addType: addType,
          type: paymentType,
          amount: paymentAmount,
          comments: paymentComments,
          date: selectedDayStr,
          clazz: "bg-info" + " text-white",
        };
      }
      else if(addType == 'Leave'){
        newEvent = {
          empid: selectedEmpId,
          addType: addType,
          type: leaveType,
          comments: leaveComments,
          date: selectedDayStr,
          clazz: "bg-danger" + " text-white",
        };
      }
      */
      // save new event
      setShowLoading(true)
      const result = await addEmployeeLedger(newEvent)
      setShowLoading(false)
      if(result.status == 'success'){
        showSuccessToast('Added Successfully!!!')
        getAllDetails(selectedEmpId)
        /*
        getEmpPaymentAndLeaves({
          inputKey: selectedEmpId
        })
        .then(resp => {
          if(resp && resp.payLeaveStats){
            setPayLeaveList(resp.payLeaveStats)
          }
          if(resp){
            setEmpPayLeaveResp(resp)
          }
          if(resp && resp.events && resp.events.length > 0){
            setEvents(convertToCalVO(resp.events))
          }
        })*/
      }
    }
    setSelectedDay(null);
    toggle();
  };

  function convertToCalVO(inp){
    const converted = []
    inp.map(each => {
      let title = ''
      if(each.addType == 'PH'){
        title = 'PH'
        if(each.comments){
          title += ': '+each.comments
        }
      }
      else if(each.addType == 'PAY'){
        title = 'Pay :' + each.amount
        if(each.comments){
          title += ': '+each.comments
        }
      }
      else if(each.addType == 'LEAVE'){
        title = 'Leave'
        if(each.leaveHours != '0'){
          title += ': '+each.leaveHours+ ' hrs'
        }
        if(each.comments){
          title += ': '+each.comments
        }
      }
      converted.push({
        id: each.id,
        title: title,
        type: each.type,
        start: each.date,
        className: each.clazz,
        amount: each.amount,
        addType: each.addType,
        comments: each.comments,
        leaveHours: each.leaveHours,
        fromAccount: each.fromAccount
      })
    })
    return converted;
  }

  const handleEventClick = arg => {
    const event = arg.event;
    
    setEvent({
      id: event.id,
      comments: event.extendedProps.comments,
      type: event.extendedProps.type,
      start: event.startStr,
      className: event.classNames[0] + " " +event.classNames[1],
      amount: event.extendedProps.amount,
      addType: event.extendedProps.addType,
      leaveHours: event.extendedProps.leaveHours,
      fromAccount: event.extendedProps.fromAccount

      //value: event.id,
      //holidaytitle: event.title,
      //holidaytype: event.type,
      //holidaydate: event.startStr,
      //className: event.classNames[0] + " " +event.classNames[1],
    });
    setSelectedDayStr(event.startStr)
    setPaymentAmount(event.extendedProps.amount)
    setPaymentComments(event.extendedProps.comments)
    setLeaveComments(event.extendedProps.comments)
    setLeaveType(event.extendedProps.type)
    setPaymentType(event.extendedProps.type)
    setLeaveHours(event.extendedProps.leaveHours)
    setFromAccount(event.extendedProps.fromAccount)

    if(event.extendedProps.leaveHours && Number(event.extendedProps.leaveHours) > 0){
      setFullDayLeave(false)
    }

    if(event.extendedProps.addType=='PAY'){
      setAddType('Payment')
    }
    else if(event.extendedProps.addType=='LEAVE'){
      setAddType('Leave')
    }
    
    //console.log('event::',event)
    if(event.extendedProps.addType !='PH'){
      setIsEdit(true);
      toggle();
    }
    
  };

  const handleDeleteEvent = async () => {
    // dispatch(onDeleteEvent(event));
    setDeleteModal(false);
    setShowLoading(true)
     const response =  await onDeleteItemDirect({
       'key': event.id,
       'value' : addType
     }, '')
     setShowLoading(false)
     
     if(response.status == 'success'){
         
       showSuccessToast('Deleted Successfully!!!')
       getAllDetails(selectedEmpId)
       /*
       getEmpPaymentAndLeaves({
        inputKey: selectedEmpId
      })
      .then(resp => {
        if(resp && resp.payLeaveStats){
          setPayLeaveList(resp.payLeaveStats)
        }
        if(resp){
          setEmpPayLeaveResp(resp)
        }
        if(resp && resp.events && resp.events.length > 0){
          setEvents(convertToCalVO(resp.events))
        }
      })*/
     }
     toggle();
   };

   const pageOptions = {
    sizePerPage: 12,
    totalSize: size(payLeaveList), 
    custom: true,
  }

  const pageOptionsDetails = {
    sizePerPage: 15,
    totalSize: size(detailedEvents), 
    custom: true,
  }

  const handleValidDate = date => {
    const myDate = moment(date, 'MMMM-YYYY').toDate();

    //const date1 = moment(new Date(date)).format("DD MMM Y")
    return myDate
  }

   const EmpPayLeaveListColumns = () => [
    {
      dataField: "monthAndYear",
      text: "Month",
      sort: true,
      sortValue: (cell, row) => handleValidDate(cell),
    },
    {
      dataField: "noOfWorkingDays",
      text: "W. days",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 1})}
        </div>
      ),
    },
    {
      dataField: "noOfLeaves",
      text: "Leaves",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 1})}
        </div>
      ),
    },
    {
      dataField: "amountToBePaid",
      text: "Total",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
        </div>
      ),
    },
    {
      dataField: "amountPaid",
      text: "Paid",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
        </div>
      ),
    },
    {
      dataField: "balance",
      text: "Balance",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
        </div>
      ),
    }
  ]

  
  const sortDate = dates => {

    const sortedArray = dates.sort((a, b) => {
      let firstDate = moment(a.date).format('YYYYMMDDHH24MMSS')
      let secondDate = moment(b.date).format('YYYYMMDDHH24MMSS')
      return secondDate-firstDate
    })
    return sortedArray
  }

  const handleValidDateForDetails = date => {
    //const myDate = moment(date, 'DD-MMM-YY').toDate();
    const myDate = moment(new Date(date)).format("DD MMM Y")
    return myDate
  }

  const EmpEventsDetailsColumns = () => [
    {
      dataField: "date",
      text: "Date",
      sort: true,
      sortValue: (cellContent, row) => handleValidDateForDetails(cellContent),
      formatter: (cellContent, row) => (
        <div>
          {handleValidDateForDetails(cellContent)}
        </div>
      ),
    },
    {
      dataField: "addType",
      text: "",
      sort: true,
      //sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {cellContent == 'PAY' ? <i className="bx bx-dollar font-size-14"></i> : <i className="bx bx-user-minus font-size-14"></i> }
        </div>
      ),
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      //sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {cellContent}
        </div>
      ),
    },
    {
      dataField: "amount",
      text: "Amt/Hours",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {row.amount && Number(row.amount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
          {row.leaveHours ? 
          Number(row.leaveHours) > 0? Number(row.leaveHours).toLocaleString('en-IN',{minimumFractionDigits: 1}) : 'Full Day' : null}
        </div>
      ),
    },
    {
      dataField: "comments",
      text: "Comments",
      formatter: (cellContent, row) => (
        <div>
          {cellContent}
        </div>
      ),
    }
  ]

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Manage" breadcrumbItem="Employee Ledger" breadcrumbLink="/list-employee"/>
          <Card>
            <CardBody className="no-x-padding">
              <Row className="">
                <Col lg="2">
                  <Row>
                    <Col className="text-center fw-medium font-size-15">
                      Employees
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3 ms-2 pt-2">
                    <Select
                      onChange={(e) => {
                        setSelectedEmployee(e)
                        if(e?.value){
                          setSelectedEmpId(e.value)
                          getAllDetails(e.value)
                          const fileredList = employeeList.filter(each => each.value == e.value)
                          setEmployeeFilteredList(fileredList)
                        }
                        else{
                          setEmployeeFilteredList(employeeList)
                        }
                      }}
                      isClearable
                      value={selectedEmployee}
                      options={employeeList}
                      classNamePrefix="select2-selection"
                      isLoading={false}
                      id="productcustomer"
                    />
                  </div>

                  <SimpleBar style={{ maxHeight: "750px" , paddingBottom:"30px"}} autoHide={false}>
                  {employeeFilteredList.map((entry, i) => (
                    <React.Fragment key={"outer"+i}>
                      {selectedEmpId == entry.value ? <div ref={messagesEndRef} key={"sel-"+i} />: null}
                      <div className={selectedEmpId == entry.value ? "border-bottom pointer-cursor-with-hover px-2 bg-light-blue" : "border-bottom pointer-cursor-with-hover px-2 "} key={i} onClick={()=>{
                        //getSalesEntryDetails(entry)
                        setSelectedEmpId(entry.value)
                        getAllDetails(entry.value)
                      }}>
                        <CardBody className="no-gutters">
                          <div className="d-flex align-items-center">
                            <div className="pe-1 border-end">
                              <i className="mdi mdi-account-circle text-primary h1"></i>
                            </div>

                            <div className="ps-2">
                              <h5>{entry.name ? entry.name : "-"}</h5>
                              {entry.address && <p className="text-muted mb-1"><i className="bx bx-id-card"/> {entry.address}</p>}
                              {entry.email && <p className="text-muted mb-1"><i className="bx bx-envelope"/> {entry.email}</p>}
                              {entry.mobile && <p className="text-muted mb-0"> <i className="bx bx-mobile"/> {entry.mobile}</p>}
                            </div>
                          </div>
                        </CardBody>
                      </div>
                    </React.Fragment>
                  ))}
                    
                  </SimpleBar>
                  {(!searchInProgress && employeeFilteredList.length == 0) && 
                    <Card color="warning" >
                      <CardBody>
                        <CardText className="font-size-16">
                          <i className="bx bx-sad me-1" /> Sorry, nothing found !!!
                        </CardText>
                      </CardBody>
                    </Card>
                  }
                </Col>
                <Col lg="10">
                {/*showLoading ? 
                <div className=" text-center">
                  <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                </div>
                : 
                <>*/}
                  <Row className="mt-1">
                    <Col className="text-end">
                      <Button
                        type="button"
                        color="warning"
                        className="btn-rounded  me-2"
                        onClick={() => {
                          handleAddNewLeaveClick()
                        }}
                      >
                        <i className="mdi mdi-plus me-1" />
                        Add New Leave
                      </Button>

                      <Button
                        type="button"
                        color="success"
                        className="btn-rounded  me-2"
                        onClick={() => {
                          handleAddNewPaymentClick()
                        }}
                      >
                        <i className="mdi mdi-plus me-1" />
                        Add New Payment
                      </Button>

                      <Button className="btn btn-sm ms-1 me-2 p-2" onClick={() => {
                          close()
                        }}
                        >
                        <i className="fas fa-window-close"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1 py-2">
                    <Col className="d-lg-flex justify-content-between">
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Working Days #
                              </p>
                              {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" /> : 
                              <h4 className="mb-0">{empPayLeaveResp.totalNoOfWorkingDays}</h4>}
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="bx bx-copy-alt font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Leaves #
                              </p>
                              {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" /> : 
                              <h4 className="mb-0">{empPayLeaveResp.totalNoOfLeaves}</h4> }
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-danger">
                                <i className="bx bx bx-x font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Total
                              </p>
                              {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" /> :
                              <h4 className="mb-0">{Number(empPayLeaveResp.totalAmountToBePaid).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4> }
                              {!showLoading && selectedEmployeeDetails.openingBalance && selectedEmployeeDetails.openingBalance != '0' &&
                              <>
                              <small>
                                OB : {Number(selectedEmployeeDetails.openingBalance).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                              </small>
                              </>}
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-info">
                                <i className="bx bx-purchase-tag-alt font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Paid
                              </p>
                              {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" /> :
                              <h4 className="mb-0">{Number(empPayLeaveResp.totalAmountPaid).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4> }
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-success">
                                <i className="bx bx-archive-in font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Balance
                              </p>
                              {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" /> :
                              <h4 className="mb-0">{(Number(empPayLeaveResp.totalBalance)+Number(selectedEmployeeDetails.openingBalance)).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4> }
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-warning">
                                <i className="bx bx-bullseye font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={7}>
                      <FullCalendar
                        plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
                          interactionPlugin,
                        ]}
                        //slotDuration={"00:15:00"}
                        handleWindowResize={true}
                        themeSystem="bootstrap"
                        contentHeight="auto"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,dayGridWeek,dayGridDay",
                        }}
                        events={events}
                        editable={true}
                        droppable={false}
                        selectable={true}
                        dateClick={handleDateClick}
                        eventClick={handleEventClick}
                      />
                    </Col>
                    <Col lg={5}>
                      <Row className="text-center">
                        <div className="mb-2 mt-2 fw-bold">
                          Summary
                        </div>
                      </Row>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="monthAndYear"
                        columns={EmpPayLeaveListColumns()}
                        data={payLeaveList}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="monthAndYear"
                            data={payLeaveList}
                            columns={EmpPayLeaveListColumns()}
                            bootstrap4
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive min-height-200">
                                      <BootstrapTable
                                        keyField="monthAndYear"
                                        responsive
                                        bordered={false}
                                        striped={false}
                                        //defaultSorted={defaultSorted}
                                        classes={
                                          "table align-middle table-hover"
                                        }
                                        headerWrapperClasses={"table-light"}
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                        noDataIndication={<div className="text-center">- No transactions found -</div>}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>

                      <Row className="text-center">
                        <div className="mb-2 fw-bold">
                          Detailed
                        </div>
                      </Row>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptionsDetails)}
                        keyField="date"
                        columns={EmpEventsDetailsColumns()}
                        data={detailedEvents}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="date"
                            data={detailedEvents}
                            columns={EmpEventsDetailsColumns()}
                            bootstrap4
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive min-height-200">
                                      <BootstrapTable
                                        keyField="date"
                                        responsive
                                        bordered={true}
                                        striped={false}
                                        //defaultSorted={defaultSorted}
                                        classes={
                                          "table align-middle table-hover"
                                        }
                                        headerWrapperClasses={"table-light"}
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                        noDataIndication={<div className="text-center">- No transactions found -</div>}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </Col>
                  </Row>
                
                </Col>
              </Row>
              
            </CardBody>

          </Card>
        </Container>
      </div>

      <Modal isOpen={modal} className={props.className}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Edit " : "Add "} {addType} {" for "}{selectedEmployeeDetails.name}
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={handleValidEventSubmit}>
            <Row form>
              <Col className="col-12 mb-3">
                <AvField
                  type="select"
                  name="addType"
                  label="Choose Type"
                  errorMessage="Select the type"
                  disabled={isEdit}
                  value={addType}
                  validate={{
                    required: { value: true },
                  }}
                  onChange={(e)=>{
                    setAddType(e.target.value)
                  }}
                >
                  <option value="Payment">Payment</option>
                  <option value="Leave">Leave</option>
                </AvField>
              </Col>
              <Col className="col-12 mb-3">
                <AvField
                  name="dDate"
                  label="Date"
                  type="date"
                  value={selectedDayStr || ''}
                  errorMessage="Invalid Date"
                  validate={{
                    required: { value: true },
                  }}
                  onChange={(e)=>{
                    setSelectedDayStr(e.target.value)
                    /*
                    console.log('eeee:',e)
                    if(e.target.value && e.target.value !=""){
                      var parts = e.target.value.split('-');
                      if(parts.length > 1){
                        var mydate = new Date(parts[0], parts[1] - 1, parts[2]); 
                        console.log('mydate:',mydate)
                        console.log('mydate:dateStr:',mydate.dateStr)
                        setSelectedDay(mydate);
                      }
                    }
                    */
                    //setAddType(e.target.value)
                  }}
                />
              </Col>

              {addType == 'Payment' && <>
                <Col className="col-12 mb-3">
                  <AvField
                    type="select"
                    name="paymentType"
                    label="Choose Payment Type"
                    errorMessage="Select the payment type"
                    value={paymentType}
                    validate={{
                      required: { value: true },
                    }}
                    onChange={(e)=>{
                      setPaymentType(e.target.value)
                    }}
                  >
                    <option value="Salary">Salary</option>
                    <option value="Incentive">Incentive</option>
                  </AvField>
                </Col>
                <Col className="col-12 mb-3">
                  <AvField
                    name="paymentAmount"
                    label="Amount"
                    type="text"
                    errorMessage="Invalid Amount"
                    validate={{
                      required: { value: true },
                      pattern: {
                        value: "^[0-9]+?(\.[0-9]{0,2})?$",
                        errorMessage: "Please enter a valid amount",
                      },
                      min: {
                        value: 1,
                        errorMessage: "Please enter a valid amount",
                      }
                    }}
                    onChange={(e)=>{
                      setPaymentAmount(e.target.value)
                    }}
                    value={paymentAmount || ""}
                  />
                </Col>
                <Col className="col-12 mb-3">
                  <AvField
                    name="paymentComments"
                    label="Comment"
                    type="text"
                    errorMessage="Invalid Comment"
                    maxLength="150"
                    validate={{
                      required: { value: false },
                    }}
                    onChange={(e)=>{
                      setPaymentComments(e.target.value)
                    }}
                    value={paymentComments || ""}
                  />
                </Col>
                <Col className="col-12 mb-3">
                  <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                    <Label>
                      From Account
                    </Label>
                    <COADropDown 
                      id={fromAccount || ''}
                      groupCode="CH,BA"
                      accountType="CASH"
                      selectOnChange={e =>{
                        setFromAccount(e.value)
                      }}
                      >
                    </COADropDown>
                  </div>
                </Col>
              </>}
              {addType == 'Leave' && <>
                <Col className="col-12 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="customControlInline"
                      checked={fullDayLeave}
                        onChange={() => {
                          if(!fullDayLeave){
                            setLeaveHours('0')
                          }
                          setFullDayLeave(!fullDayLeave)
                        }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customControlInline"
                    >
                      Full Day
                    </label>
                  </div>
                </Col>
                {!fullDayLeave && 
                <Col className="col-12 mb-3">
                  <AvField
                    name="leaveHours"
                    label="Leave Hours"
                    type="text"
                    errorMessage="Invalid hours"
                    validate={{
                      required: { value: true },
                      pattern: {
                        value: "^[0-9]+?(\.[0-9]{0,2})?$",
                        errorMessage: "Please enter a valid hours",
                      },
                      min: {
                        value: 1,
                        errorMessage: "Please enter a valid hours",
                      },
                      max: {
                        value: selectedEmployeeDetails.workinghours ? Number(selectedEmployeeDetails.workinghours) : 10,
                        errorMessage: "Please enter a valid hours.",
                      }
                    }}
                    onChange={(e)=>{
                      setLeaveHours(e.target.value)
                    }}
                    value={leaveHours || ""}
                  />
                  <small>Max working hours : {selectedEmployeeDetails.workinghours}</small>
                </Col>}
                <Col className="col-12 mb-3">
                  <AvField
                    type="select"
                    name="leaveType"
                    label="Choose Leave Type"
                    errorMessage="Select the leave type"
                    value={leaveType}
                    validate={{
                      required: { value: true },
                    }}
                    onChange={(e)=>{
                      setLeaveType(e.target.value)
                    }}
                  >
                    <option value="Planned">Planned</option>
                    <option value="Sick">Sick</option>
                  </AvField>
                </Col>
                <Col className="col-12 mb-3">
                  <AvField
                    name="leaveComments"
                    label="Comment"
                    type="text"
                    errorMessage="Invalid Comment"
                    maxLength="150"
                    validate={{
                      required: { value: false },
                    }}
                    onChange={(e)=>{
                      setLeaveComments(e.target.value)
                    }}
                    value={leaveComments || ""}
                  />
                </Col>
              </>}
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={toggle}
                  >
                    Close
                  </button>
                  {!!isEdit && (
                    <button
                      type="button"
                      disabled={showLoading}
                      className="btn btn-danger me-2"
                      onClick={() => setDeleteModal(true)}
                    >
                      Delete
                      {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" />}
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={showLoading}
                    className="btn btn-success save-event"
                  >
                    Save
                    {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-1" color="primary" />}
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>

    </React.Fragment>
  )
}

export default EmployeeListDetailed
